package net.frozenbit.games.soundgame.utils

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.runningFold

internal data class WithPrevious<T>(
    val previous: T?,
    val current: T,
)

internal fun <T> Flow<T>.withPrevious(): Flow<WithPrevious<T>> =
    runningFold<T, WithPrevious<T>?>(null) { acc, current ->
        WithPrevious(
            previous = acc?.current,
            current = current,
        )
    }.filterNotNull()

